import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  accountEmailById,
  avatarUrlById,
  fullNameById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import {Header} from './Header';

const withCurrentUserCoachId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    userId,
    name: withCurrentUserCoachId(fullNameById),
    avatar: withCurrentUserCoachId(avatarUrlById),
    email: withCurrentUserCoachId(accountEmailById),
  }),
)(Header);
